import { SIGNAL_META, type SignalCategory } from '@/lib/signals'
import { cx } from '@/lib/ui'

/**
 * What kind of signal a port carries.
 *
 * This is the most repeated mark in the app — one per port row, so a router
 * detail page draws two hundred of them. As a filled uppercase capsule that was
 * a wall of colour that hid the port names it was meant to annotate. The dot
 * keeps the colour coding, which is the part people actually read along the
 * row, and gives the name back its own weight.
 */
export function SignalChip({
  signal,
  className,
}: {
  signal: SignalCategory
  className?: string
}) {
  const meta = SIGNAL_META[signal]
  return (
    <span
      className={cx('inline-flex items-center gap-1.5 text-[11px] font-medium', className)}
      style={{ color: meta.text }}
    >
      <span
        aria-hidden="true"
        className="h-1.5 w-1.5 shrink-0 rounded-full"
        style={{ backgroundColor: meta.color }}
      />
      {meta.label}
    </span>
  )
}
